import { SagaIterator } from "redux-saga";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { CreateOverdueReportRequest, OverdueReportReduxTypes } from "./types";
import { createOverdueReportApi } from "./api";

function* createOverdueReport({ payload }: CreateOverdueReportRequest): SagaIterator {
    try {
        const response = yield call(createOverdueReportApi, payload);
        yield put({
            type: OverdueReportReduxTypes.OVERDUE_REPORT_SUCCESS,
            payload: { data: response.data.data }
        })
    } catch (error: any) {
        yield put({
            type: OverdueReportReduxTypes.OVERDUE_REPORT_ERROR,
            payload: { error: error }
        })
    }
}

export function* watchCreateOverdueReport() {
    yield takeEvery(OverdueReportReduxTypes.OVERDUE_REPORT, createOverdueReport)
}

function* overdueReportSaga() {
    yield all([fork(watchCreateOverdueReport)])
}

export default overdueReportSaga;
